import React from 'react';
import TextField from '@mui/material/TextField';
import FieldLabel from '../components/FieldLabel';
import { getFieldLabel, blockInvalidNumberKeys, sanitizeNumberInput } from '../utils/formHelpers';
import { outlinedFieldProps } from '../utils/fieldStyles';

const NumberField = ({ field, data, change, hasError, errorMessage, basePrice }) => {
    const numberValue = data[field.key];
    const packageMin = field.validateAgainstPackageBasePrice
        && basePrice !== undefined
        && basePrice !== null
        && basePrice !== ''
        ? parseFloat(basePrice)
        : undefined;
    const inputMin = field.min
        ?? field.validateMin
        ?? (Number.isFinite(packageMin) ? packageMin : undefined);
    const priceHint = Number.isFinite(packageMin) ? `Must be ≥ package price (${packageMin})` : '';
    return (
        <TextField
            {...outlinedFieldProps}
            label={<FieldLabel label={getFieldLabel(field)} tooltip={field.tooltip} />}
            type="number"
            placeholder={field.placeholder}
            value={numberValue === 0 || numberValue ? numberValue : ''}
            onKeyDown={blockInvalidNumberKeys}
            onChange={(e) => change(field.key, sanitizeNumberInput(e.target.value))}
            error={hasError}
            helperText={hasError ? (errorMessage || 'This field is required') : priceHint}
            inputProps={{
                inputMode: 'decimal',
                ...(inputMin !== undefined ? { min: inputMin } : {}),
                ...(field.max !== undefined ? { max: field.max } : {}),
                ...(field.min !== undefined ? { step: 1 } : {}),
            }}
        />
    );
};

export default NumberField;
